import { render } from "./VeiculosRevisao.vue?vue&type=template&id=1e5cff4b&scoped=true&ts=true"
import script from "./VeiculosRevisao.vue?vue&type=script&lang=ts"
export * from "./VeiculosRevisao.vue?vue&type=script&lang=ts"

import "./VeiculosRevisao.vue?vue&type=style&index=0&id=1e5cff4b&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5cff4b"]])

export default __exports__